export function needsOnboarding(user) {
  if (!user || user.role !== "seller" || user.impersonated_by) return false;
  return user.profile?.onboarding?.done === false;
}

export function needsBilling(user) {
  if (!user || user.role !== "seller" || user.impersonated_by) return false;
  const sub = user.profile?.subscription || user.subscription;
  const status = sub?.status;
  if (status === "required" || status === "past_due") return true;
  if (status === "grandfathered") return false;
  if (typeof user.needs_billing === "boolean") return user.needs_billing;
  if (status === "active") {
    if (!sub.current_period_end) return false;
    const end = Date.parse(sub.current_period_end);
    return !Number.isNaN(end) && end <= Date.now();
  }
  return false;
}

export const AUTH_LOGIN = "/auth?mode=login";

export function sellerHome(user) {
  if (!user) return AUTH_LOGIN;
  if (user.role === "admin") return "/admin";
  if (user.role === "seller") {
    if (needsBilling(user)) return "/seller/subscribe";
    return needsOnboarding(user) ? "/seller/onboarding" : "/seller";
  }
  if (user.role === "developer") return "/developers/console";
  return "/shop";
}
